import type { StepProps } from "../types";
import { Field, Input, Select } from "@/components/ui";

const AU_STATES = ["QLD", "NSW", "VIC", "TAS", "SA", "WA", "NT", "ACT"] as const;

export default function Step1Identity({ context, draft, updateField }: StepProps) {
  const emp = context.employee;
  const isFirstTime = !emp && Object.keys(draft).length === 0 && context.is_self;

  return (
    <div>
      {isFirstTime && (
        <div className="mb-4 p-4 rounded-md bg-accent/5 border border-accent/20">
          <p className="text-sm">
            <span className="font-medium">Welcome to Coretel Ops.</span>{" "}
            <span className="text-text-muted">
              Take a few minutes to set up your profile. You can save and come back later if needed.
            </span>
          </p>
        </div>
      )}
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
      <Field label="First name *">
        <Input
          type="text"
          value={draft.first_name ?? emp?.first_name ?? ""}
          onChange={e => updateField("first_name", e.target.value)}
        />
      </Field>

      <Field label="Middle name">
        <Input
          type="text"
          value={draft.middle_name ?? emp?.middle_name ?? ""}
          onChange={e => updateField("middle_name", e.target.value)}
        />
      </Field>

      <Field label="Last name *">
        <Input
          type="text"
          value={draft.last_name ?? emp?.last_name ?? ""}
          onChange={e => updateField("last_name", e.target.value)}
        />
      </Field>

      <Field label="Preferred name" hint="what you go by if different from first name">
        <Input
          type="text"
          value={draft.preferred_name ?? emp?.preferred_name ?? ""}
          onChange={e => updateField("preferred_name", e.target.value)}
        />
      </Field>

      <Field label="Date of birth *">
        <Input
          type="date"
          value={draft.date_of_birth ?? emp?.date_of_birth ?? ""}
          onChange={e => updateField("date_of_birth", e.target.value)}
        />
      </Field>

      <Field label="Mobile *">
        <Input
          type="tel"
          inputMode="numeric"
          placeholder="0400 000 000"
          value={draft.mobile ?? emp?.mobile ?? ""}
          onChange={e => updateField("mobile", e.target.value)}
        />
      </Field>

      <Field label="Email *">
        <Input
          type="email"
          value={draft.email ?? emp?.email ?? context.auth_email ?? ""}
          onChange={e => updateField("email", e.target.value)}
        />
      </Field>

      <Field label="Home phone">
        <Input
          type="tel"
          inputMode="numeric"
          value={draft.home_phone ?? emp?.home_phone ?? ""}
          onChange={e => updateField("home_phone", e.target.value)}
        />
      </Field>

      <div className="md:col-span-2">
        <Field label="Address line 1 *">
          <Input
            type="text"
            value={draft.address_line1 ?? emp?.address_line1 ?? ""}
            onChange={e => updateField("address_line1", e.target.value)}
          />
        </Field>
      </div>

      <div className="md:col-span-2">
        <Field label="Address line 2">
          <Input
            type="text"
            value={draft.address_line2 ?? emp?.address_line2 ?? ""}
            onChange={e => updateField("address_line2", e.target.value)}
          />
        </Field>
      </div>

      <Field label="Suburb *">
        <Input
          type="text"
          value={draft.suburb ?? emp?.suburb ?? ""}
          onChange={e => updateField("suburb", e.target.value)}
        />
      </Field>

      <Field label="State *">
        <Select
          value={draft.state ?? emp?.state ?? ""}
          onChange={e => updateField("state", e.target.value)}
        >
          <option value="">—</option>
          {AU_STATES.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </Select>
      </Field>

      <Field label="Postcode *">
        <Input
          type="text"
          inputMode="numeric"
          pattern="\d{4}"
          maxLength={4}
          value={draft.postcode ?? emp?.postcode ?? ""}
          onChange={e => updateField("postcode", e.target.value)}
        />
      </Field>
      </div>
    </div>
  );
}
